import styled from 'styled-components'

export const PageArticle = styled.article`
	padding: 6em calc(2em + 1vw);
	padding: 10vh calc(2em + 1vw);
	background-color: ${({ theme, bgColor }) => theme.color[bgColor]};
	position: relative;
`
